var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-left":"20px"}},[_c('p'),_c('h3',[_vm._v(_vm._s(_vm.$t('Unauthorized.title')))]),_c('p'),_c('p',[_vm._v(_vm._s(_vm.$t('Unauthorized.body')))])])}
var staticRenderFns = []

export { render, staticRenderFns }